import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "article-page" }

import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router'
import { onMounted, onBeforeUnmount } from 'vue'
import MarkdownArticle from '@/components/MarkdownArticle.vue'

import { getArticleMeta } from '@/utils/articles'

export default /*@__PURE__*/_defineComponent({
  __name: 'ArticlePage',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const { t } = useI18n();

const articleId = route.params.id as string

// Inject BlogPosting JSON-LD for SEO with dates/keywords
let ldEl: HTMLScriptElement | null = null
onMounted(async () => {
  try {
    const url = typeof window !== 'undefined' ? window.location.href : `https://dimflix.github.io/articles/${articleId}`
    const lang = (route.params.lang as string) || 'en'
    const meta = await getArticleMeta(lang, articleId)
    const data: any = {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: (meta?.title || document.title || `Article ${articleId}`),
      mainEntityOfPage: { '@type': 'WebPage', '@id': url },
      author: { '@type': 'Person', name: 'DIMFLIX', url: 'https://x.com/dimflix' }
    }
    if (meta?.date) data.datePublished = meta.date
    if (meta?.updatedAt) data.dateModified = meta.updatedAt
    if (meta?.keywords?.length) data.keywords = meta.keywords

    ldEl = document.createElement('script')
    ldEl.type = 'application/ld+json'
    ldEl.text = JSON.stringify(data)
    document.head.appendChild(ldEl)
  } catch {}
})

onBeforeUnmount(() => {
  if (ldEl && ldEl.parentNode) ldEl.parentNode.removeChild(ldEl)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
      }, "← " + _toDisplayString(_unref(t)('articles.back')), 1),
      _createVNode(MarkdownArticle, { "article-name": _unref(articleId) }, null, 8, ["article-name"])
    ])
  ]))
}
}

})